import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Modal } from 'antd';

const generateMessage = (expireDays: number): string => {
  if (expireDays < 0) {
    const countdown = 15 + expireDays;
    return `系统将于${Math.max(
      0,
      countdown,
    )}天后关闭登录权限，届时将停止全部功能。您的相关数据我们将为您保留6个月，超过6个月后，您的相关数据将有被清除风险!如需迁移数据，请您于${Math.max(
      0,
      countdown,
    )}日内，联系衣者售后人员协助您完成数据迁移。售后专线: 180 2957 5364。感谢您的理解与配合。`;
  } else if (expireDays <= 15 && expireDays >= 0) {
    return `您的VIP还有${expireDays}天到期,为避免影响使用,请购买续费,联系电话: 180 2957 5364`;
  }
  return ''; // 如果不需要显示消息，可以返回空字符串或处理其他情况
};

const NoticeAlert = (props: { expire_les_time: string | number }) => {
  const msg = generateMessage(+props.expire_les_time);

  const config = {
    title: '提示',
    cancelButtonProps: {
      style: {
        display: 'none',
      },
    },
    // 使用dangerouslySetInnerHTML来插入包含HTML的字符串
    content: <span dangerouslySetInnerHTML={{ __html: msg }} />,
  };

  const handleAlertClick = () => {
    Modal.confirm(config);
  };

  return (
    <Alert
      onClick={handleAlertClick}
      icon={
        <div style={{ width: '80%' }}>
          <InfoCircleOutlined />
          {msg}
        </div>
      }
      style={{
        width: '100%',
        position: 'fixed',
        top: '54px',
        cursor: 'pointer',
        color: 'red',
        zIndex: 99,
      }}
      banner={true}
      type="error"
    />
  );
};

export default NoticeAlert;
